////////////////////////////////////////////////////////////////////////////////
// Services
////////////////////////////////////////////////////////////////////////////////

class Services extends Pages {

	// ===========================================================================
	// Constructor
	// ===========================================================================

	constructor(entry) {
		super(entry)
	}

	// ===========================================================================
	// Initialisation
	// ===========================================================================

	/**
	 * The entry needs to be passed in here so that this class can update the data
	 * used for this class instance. Otherwise it will always stay the same no matter
	 * what page you go to nest.
	 * @param  {Object} entry
	 */

	init(entry) {
		this.update.entry(entry)
	}

		// ===========================================================================
	// Load In
	// ===========================================================================

	/**
	 * This is run when navigating to a country page
	 * @param  {Object}   content jQueryified object with mark up blocks.
	 * @param  {Function} done    The callback to tell the historyAPI that the page has finished loading
	 */

	in(content, done) {

		// FAQ ---------------------------------------------------------------------

		let container = content.find('.faq')

		if ( container ) {
			let buttons   = container.find('nav button')
			let sections  = container.find('section')

			buttons.on('click', e => {
				e.preventDefault()
				buttons.removeClass("current");
				sections.removeClass("current");
				$(e.currentTarget).addClass("current")
				$(sections[$(e.currentTarget).index()]).addClass("current")
			})
		}

		// How does it work --------------------------------------------------------

		let howItWorks = content.find('.how-it-works')

		let autoRun = true
		let autoIndex = 1

		if ( howItWorks ) {
			let buttons   = howItWorks.find('nav button')
			let slides  = howItWorks.find('.container article')

			buttons.on('click', e => {
				e.preventDefault()
				buttons.removeClass("current");
				slides.removeClass("current");
				$(e.currentTarget).addClass("current")
				$(slides[$(e.currentTarget).index()]).addClass("current")
				autoRun = false;
			})

			const runSlides = () => {
				if(autoRun) {
	
					setTimeout(runSlides, 6000)

					buttons.removeClass("current");
					slides.removeClass("current");
					$(buttons[autoIndex]).addClass("current")
					$(slides[autoIndex]).addClass("current")
	
					autoIndex++

					if(autoIndex >= slides.length ){
						autoIndex = 0
					}
	
				} 
	
			}

			setTimeout(runSlides, 7000)




		}


	



		// Replace this for a special transition in for this country page
		page.in(content, done)

	}

}
